import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDAlert, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { PoweredByRel } from 'Organisms/PoweredByRel';

export const KYCOrganismLayout = ({ startKYC, inKYC, setInKYC }) => {
  const { resource, consumeAttr } = useMetaLayoutContext();

  const poweredBy = resource.withRelationship(
    fr.relationships.poweredBy.name,
    (rel) => (<PoweredByRel relationship={rel} />),
    () => null,
  );

  return (
    <FDStack direction="column" spacing={3}>
      <FDAlert
        title={consumeAttr('calloutTitle')}
        description={consumeAttr('calloutDescription')}
        status="info"
      />

      <FDPrimaryActionButton
        {...dataAttrs('start-kyc-btn', resource)}
        label="Start identity verification"
        onClick={() => {
          startKYC();
          setInKYC(true);
        }}
        disabled={inKYC}
        alignSelf="center"
      />

      {poweredBy}
    </FDStack>
  );
};

KYCOrganismLayout.defaultProps = {
};

KYCOrganismLayout.propTypes = {
  startKYC: PropTypes.func.isRequired,
  inKYC: PropTypes.bool.isRequired,
  setInKYC: PropTypes.func.isRequired,
};
